import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { StepathonApi } from '../../../services'
import { Breadcrumb, Heading, Input, RadioGroup } from '../../common/atoms'
import { successOrFailureToaster } from '../../common/atoms/messages'
import { DatePicker } from '../../tailwind/molecules'
import CreateOrUpdateModelStepathon from '../../modals/CreateOrUpdateModelStepathon'
import { SALES_ROLE } from '../../../constants/overview'
import { calculateMilestoneSteps, calculateNoOfDays } from './StepathonBussinessLogic'

 
const UpdateStepathonPage = () => {
 const [state, setState] = useState({
   formValues: { name : '', start_date : '', end_date : '', max_user_steps_per_day : '', stepathon_type : '' },
   errors : {},
   openModal : false
 })
 const history = useHistory()
 const location = useLocation()
 
 const setSubState = (newState) => {
   setState(prevState => { return {...prevState, ...newState } })
 }
 
 const navigateToUpdateStepathon =() =>{
   if(Validatestepathon(state.formValues)){
     const value = state.openModal
     setSubState({ openModal : !value })
   }
 }
 
 const changeHandler = (name,value) =>{ 
   setSubState({ formValues: { ...state.formValues, [name]: value } , errors : {}})
 }
 
 const Validatestepathon = (formValues) =>{
   let newError = {}
   if (!formValues.name) {
     newError = {...newError, name : 'Name of the stepathon is mandatory'}
   }
   else if (!formValues.max_user_steps_per_day) {
     newError = {...newError, max_user_steps_per_day : 'Enter the steps limit per day per person'}
   }
   else if (formValues.max_user_steps_per_day > 25000) {
    newError = {...newError, max_user_steps_per_day : '25000 steps maximum limit per day for an individual'}
   }
   else if (!formValues.start_date) {
     newError = {...newError, start_date : 'Please enter date in correct format'}
   }
   else if (isNotValid(moment().format('DD-MM-YYYY'), formValues.start_date, 1) && !disabledDate) {
     newError = {...newError, start_date : 'Date can not be less than or equal to the current date'}
   }
   else if (!formValues.end_date) {
     newError = {...newError, end_date : 'Please enter date in correct format'}
   }
   else if (isNotValid(formValues.start_date, formValues.end_date )) {
     newError = {...newError, end_date : 'Date can not be less than the start date'}
   }
   else if (isNotValid(moment().format('DD-MM-YYYY'),formValues.end_date, 1)) {
    newError = {...newError, end_date : 'Date can not be less than the current date'}
  }
  setSubState({errors : newError})
   return Object.keys(newError || {}).length === 0
 }
 
 const isNotValid = (startDate, endDate, value = 0)=>{
   if(!startDate || !endDate) return false
   const diffDays = moment(endDate, 'DD-MM-YYYY').diff(moment(startDate, 'DD-MM-YYYY'), 'days')
   if(diffDays < value) return true
   return false
 }
 const  updateStepathon = (e,data) =>{
  let stepathon_mode = data[0]?.stepathon_mode === 'company_wide' ? 'company_wide' : 'closed'
  StepathonApi.updateStepathon(
     {id : data[0].id , data: { stepathon: {
       start_date : `${data[0].start_date}`,
       end_date : `${data[0].end_date}`,
       name : `${data[0].name}`,
       max_user_steps_per_day : `${data[0].max_user_steps_per_day}`,
       stepathon_type : `${data[0].stepathon_type?.toLowerCase()}`,
       stepathon_mode : `${stepathon_mode}`,
       target_milestone_steps : `${data[0].target_milestone_steps}`
     }}},
     (resp) => {
       const data = resp.data
       setSubState({ formValues: { ...data } })
       successOrFailureToaster({ message:  'Stepathon is succesfully updated'})
       history.push('/stepathon')
     },
     (_) => {
      setSubState({openModal : false})
      successOrFailureToaster({ message:  'There is already Stepathon scheduled in this time frame!', type :'fail'})   
     }
   );
 }
 
 useEffect(()=>{
   setSubState({ formValues: { ...location.state.data } })
 },[location])

const {formValues} = state

useEffect(() => {
  if(formValues.stepathon_type == 'milestone') {
    if(formValues.start_date && formValues.end_date && formValues.max_user_steps_per_day) {
      const target_milestone_steps = calculateMilestoneSteps(formValues.max_user_steps_per_day, calculateNoOfDays(formValues.start_date, formValues.end_date), location.state.total_employee_count)
      setSubState({ formValues: { ...state.formValues, target_milestone_steps } })
    }
  }
}, [formValues.start_date, formValues.end_date, formValues.max_user_steps_per_day])
 
 let disabledDate = (formValues.tag === 'Ongoing' ? true : false)
 return (
   <React.Fragment>
      <Breadcrumb
       list={[
         { text: 'Engagement', link: '/stepathon' },
         { text: 'Stepathon', link: '/stepathon' },
         { text: 'Update stepathon', link: '#' }
       ]}
       classes='mb-1'
     />
    <Heading
      mainHeading='Edit stepathon'
      mainClasses='text-gray-800 text-xl font-semibold leading-5'
      subHeading='An activity to boost up for your employees health and fitness'
      subClasses='text-sm text-gray-600'
    />
    <div className='mt-6'>
      <div className='bg-white p-6 rounded-t-md'>
        <div className='w-1/2'>
         <Input
           label='NAME OF THE STEPATHON' 
           labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
           type='text'
           name ='name'
           disabled ={disabledDate}
           value={formValues.name}
           inputClasses={`text-base font-semibold leading-4 ${disabledDate ? 'cursor-points-none text-gray-300': 'text-gray-700'}`}
           error={state.errors.name}
           onChange = {(e) => {
             let {name , value} = e.target
             var letters = /^[a-zA-Z\s]*$/;
             if(!value.match(letters)) return false
             value = (value === ' ' ? value.trim() : value )
             changeHandler(name, value)
            }
           }/>
           <div className='mt-6 flex flex-col'>
           <RadioGroup
             radioList={['Individual', 'Team', 'Milestone']}
             value={formValues.stepathon_type}
             radioInputClasses ='cursor-not-allowed h-6 w-6 text-gray-400 border-gray-275'
             labelClases='font-proxima-nova text-gray-300 text-base font-semibold ml-4'
             subTitleClasses= 'ml-10 mb-6 font-proxima-nova text-gray-275'
             disabled ={true}
             name = 'stepathon_type'
             error = {state.errors.stepathon_type}
             handler={(e) => {
               let {name,value} = e.target
               changeHandler(name, value)
             }} 
             radioClasses='flex flex-col mt-3'
             subTitle={['Lets your employee participate individually in the Stepathon','Lets your employee create teams and participate with their teams in the Steapthon']} 
             title='STEPATHON FOR'  
             titleClasses='text-xs  font-semibold tracking-widest leading-3 text-gray-500'
           />
         </div>
          <Input
            label='STEPS LIMIT'
            subLabel='25000 steps maximum limit per day for an individual'
            subLabelClasses='text-sm leading-3 text-gray-500 mb-3'
            name= 'max_user_steps_per_day'
            labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
            inputClasses={`text-base font-semibold leading-4 ${disabledDate ? 'cursor-points-none text-gray-300': 'text-gray-700'}`}
            disabled ={disabledDate}
            value={formValues.max_user_steps_per_day}
            error={state.errors.max_user_steps_per_day}
            onChange = {(e) => 
              {
                let {name , value} = e.target
                var numbers = /^[0-9]*$/;
                if(!value.match(numbers)) return false
                changeHandler(name, value)
              }
            }
          />
         <div className='mt-6'>
         <DatePicker
             labelClasses='font-semibold tracking-widest leading-3  mt-6 mb-3'
             label='START DATE'
             value = {formValues.start_date}
             inputClasses=' text-gray-700 bg-gray-100 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#7c8cab'
             size='12px'
             disabled ={disabledDate}
             error={state.errors.start_date}
             handler={(value) => {
               let name='start_date'
               changeHandler(name, value)
             }} 
           />
           <DatePicker
             labelClasses='font-semibold tracking-widest leading-3 mb-3 mt-6'
             label='END DATE'
             value = {formValues.end_date}
             inputClasses='text-gray-700 bg-gray-100 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#7c8cab'
             size='12px'
             error={state.errors.end_date}
             handler={(value) => {
               let name='end_date'
               changeHandler(name, value)
             }} 
           />
           {formValues.stepathon_type == 'milestone' && <div className='mt-6'>
              {formValues.stepathon_type == 'milestone' && <div className='w-full mt-3'>
                <Input
                  subLabel='Steps count for the milestone'
                  subLabelClasses='text-sm leading-3 text-gray-500 mb-3'
                  name= 'target_milestone_steps'
                  inputClasses='text-base font-semibold text-gray-700 leading-4 w-full'
                  value={formValues.target_milestone_steps}
                  error={state.errors.max_user_steps_per_day}
                  onChange = {(e) =>
                    {
                      let {name , value} = e.target
                      var numbers = /^[0-9]*$/;
                      if(!value.match(numbers)) return false
                      changeHandler(name, value)
                    }
                  }
                />
              </div>}
           </div>}
         </div>
        </div>
       </div>
       <div className='flex flex-row justify-end px-8 py-4 rounded-b-md border'
         style={{backgroundColor : '#F5F8FF'}}
       >
         <button
           className='mr-4 text-blue-600  border block rounded-md font-semibold bg-white text-base px-6 py-3'
           onClick={() => history.goBack('/stepathon') }
           >
             Cancel
         </button>
         <button
         type='submit'
         onClick={navigateToUpdateStepathon}
         disabled={SALES_ROLE === "sales"}
         className={`block rounded-md leading-5 py-3 bg-blue-600 border-none text-base font-semibold text-white focus:outline-none px-6 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
       >
         Update stepathon
       </button>
       </div>
    </div>
     {  state.openModal &&
       <CreateOrUpdateModelStepathon
       visible={state.openModal}
       text='update'
       subTitle='You can edit all the details of Stepathon before it is live and only change the end date after it is live.'
       btnText='Update stepathon'
       data={[state.formValues]}
       onCancel={navigateToUpdateStepathon}
       handler={updateStepathon}
       />
     }
   </React.Fragment>
 )
}
 
export default UpdateStepathonPage